module.exports = __webpack_public_path__ + "frontend/images/white/carousel/europe.png?41ee74c431f1d3cc7b8e9d58b250fb6a";